import {useState} from 'react'
import PurchaseInvoiceForm from './PurchaseInvoiceForm';
import PurchaseInvoiceListview from './PurchaseInvoiceListview';

const PurchaseInvoice = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <PurchaseInvoiceForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <PurchaseInvoiceListview addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}
      </>

    )
}

export default PurchaseInvoice